export enum NewsStatusEnum {
    All = 0,
    /// <summary>
    /// Lưu tạm
    /// </summary>
    Temporary = 1,
    /// <summary>
    /// Đợi biên tập
    /// </summary>
    WaitForEdit = 2,
    /// <summary>
    ///  Nhận biên tập
    /// </summary>
    ReceivedForEdit = 3,
    /// <summary>
    /// Trả lại phóng viên
    /// </summary>
    ReturnedToReporter = 4,
    /// <summary>
    /// Gửi lên chờ xuất bản
    /// </summary>
    WaitForPublish = 5,
    /// <summary>
    /// Nhận xuất bản
    /// </summary>
    ReceivedForPublish = 6,
    /// <summary>
    /// Trả lại biên tập viên
    /// </summary>
    ReturnedToEditor = 7,
    /// <summary>
    /// Gửi lên TBT
    /// </summary>
    WaitForTBT = 8,

    /// <summary>
    /// TBT nhận
    /// </summary>
    ReceivedForTBT = 9,

    /// <summary>
    /// Xuất bản
    /// </summary>
    Published = 10,

    /// <summary>
    /// Gỡ xuất bản
    /// </summary>
    Unpublished = 11,

    /// <summary>
    /// Xóa tạm
    /// </summary>
    MovedToTrash = 12,

    /// <summary>
    ///TBT trả lại
    /// </summary>
    TBTReturned = 13,

    /// <summary>
    /// Trả về Cộng tác viên
    /// </summary>
    ReturnToCooperator = 14,
}

export const NewsStatusObjectEnum: { [key: number]: object } = {
    0: {
        title: "của tôi",
        badge: "secondary",
        icon: ""
    },
    /// <summary>
    /// Lưu tạm
    /// </summary>
    1: {
        title: "lưu tạm",
        badge: "secondary",
        icon: "notepad-edit"
    },
    /// <summary>
    /// Đợi biên tập
    /// </summary>
    2: {
        title: "chờ biên tập",
        badge: "primary",
        icon: "arrow-up"
    },
    /// <summary>
    ///  
    /// </summary>
    3: {
        title: "nhận biên tập",
        badge: "primary",
        icon: "arrow-down"
    },
    /// <summary>
    /// 
    /// </summary>
    4: {
        title: "trả lại",
        badge: "primary",
        icon: "arrow-circle-left"
    },
    /// <summary>
    /// Gửi lên chờ xuất bản
    /// </summary>
    5: {
        title: "chờ xuất bản",
        badge: "primary",
        icon: "exit-up"
    },
    /// <summary>
    /// Nhận xuất bản
    /// </summary>
    6: {
        title: "nhận xuất bản",
        badge: "primary",
        icon: "exit-down"
    },
    /// <summary>
    /// Trả lại biên tập viên
    /// </summary>
    7: {
        title: "trả lại",
        badge: "primary",
        icon: "arrow-circle-left"
    },
    /// <summary>
    /// Gửi lên TBT
    /// </summary>
    8: {
        title: "gửi lên TBT",
        badge: "primary",
        icon: "arrow-up-right"
    },

    /// <summary>
    /// TBT nhận
    /// </summary>
    9: {
        title: "TBT nhận",
        badge: "info",
        icon: "exit-down"
    },

    /// <summary>
    /// Xuất bản
    /// </summary>
    10: {
        title: "xuất bản",
        badge: "success",
        icon: "shield-tick"
    },

    /// <summary>
    /// Gỡ xuất bản
    /// </summary>
    11: {
        title: "đã gỡ",
        badge: "danger",
        icon: "shield-cross"
    },

    /// <summary>
    /// Xóa tạm
    /// </summary>
    12: {
        title: "đã xóa",
        badge: "dark",
        icon: "trash"
    },

    /// <summary>
    ///TBT trả lại
    /// </summary>
    13: {
        title: "TBT trả lại",
        badge: "warning",
        icon: "arrow-circle-left "
    },

    /// <summary>
    /// Trả về Cộng tác viên
    /// </summary>
    14: {
        title: "trả lại",
        badge: "warning",
        icon: "arrow-circle-left "
    },
};


export enum PermissonEnum {
    ///Xem
    Read = 1,

    ///Viết
    Create = 2,

    ///Sửa
    Update = 4,

    ///Xóa
    Delete = 8,

    ///Biên tập
    Editing = 16,

    ///Xuất bản
    Publish = 32,

    ///Gỡ bài
    UnPublish = 64,

    ///Gửi Tổng Biên Tập
    SendTBT = 128,

    ///Tổng Biên Tập
    TBT = 256,

    ///Cài đặt
    Setting = 1024,

    ///Toàn quyền chức năng
    Full = 1073741824,

    ///None
    Allow = 34359738368,
}

export enum ModuleEnum {
    Document = 1,
    Category = 2,
    InsuranceCompany = 3,
    MedicalFacility = 4,
    Role = 98,
    User = 99,
}